/**
 * A count, written the way the language writes one.
 *
 * The phone sets every count with `format: .number` — the profile's three
 * figures, the follow list's total, the days a film has collected — and a
 * thousand reads "1,095" in English, "1 095" in Russian, "1.095" in
 * Indonesian. The web wrote the digits raw. Small numbers are the same
 * either way; a diary three years deep is not, and neither is a follower
 * count that has grown.
 *
 * The sentences that carry a count go through i18next's own `number`
 * format instead (`{{count, number}}` in the resources); this is for the
 * figures that stand alone.
 */
export function formatCount(value: number, locale: string): string {
  return new Intl.NumberFormat(locale).format(value);
}
